import axios from 'axios'
import { dbFirestore,enviometodosRef,usuarioRef, pedidosRef,pedidosContRef, categoriasRef, productosRef, authRef } from "../config/firebase";

export const GET_PRODUCTOS = 'GET_PRODUCTOS'
export const GET_PRODUCTO = 'GET_PRODUCTO'
export const TRAE_PRODUCTO = 'TRAE_PRODUCTO'
export const TRAE_PRODUCTO_NEW = "TRAE_PRODUCTO_NEW";
export const GET_RUBRO = 'GET_RUBRO'
export const CAMBIA_GAL = 'CAMBIA_GAL'
export const ADDEL_PRODUCTO = 'ADDEL_PRODUCTO'
export const GET_MENU = 'GET_MENU'
export const CIERRA_MENU = 'CIERRA_MENU'
export const GET_FLIAS = 'GET_FLIAS'
export const ENVIA_CONTACTO = 'ENVIA_CONTACTO'
export const ADD_CART = 'ADD_CART'

export const ELIMINA_PROD_CARRO = "ELIMINA_PROD_CARRO";

export const REGISTRA_USER = 'REGISTRA_USER'
export const LOG_USER = 'LOG_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const TRAE_USER = 'TRAE_USER'
export const SEND_USER_MSJ = 'SEND_USER_MSJ'
export const UPDATE_STAT = 'UPDATE_STAT'
export const RESET_PASS = 'RESET_PASS'
export const SEND_USER = "SEND_USER";
  
export const ADD_DIRECCION = 'ADD_DIRECCION'
export const UPDATE_DIRECCION = 'UPDATE_DIRECCION'
export const DEL_DIRECCION = 'DEL_DIRECCION'
export const TRAE_DIRECCION = 'TRAE_DIRECCION'
export const TRAE_DIRECCIONES = 'TRAE_DIRECCIONES'

export const GET_PEDIDOS = 'GET_PEDIDOS'
export const GET_PEDIDO = 'GET_PEDIDO'

export const ADD_PEDIDO = 'ADD_PEDIDO'
export const SACA_PRODUCTO = 'SACA_PRODUCTO'
export const LIMPIA_CARRO = 'LIMPIA_CARRO'
export const SEND_PEDIDO = 'SEND_PEDIDO'
export const GUARDA_PAGO = 'GUARDA_PAGO'

export const GET_PRODUCTOS_ADMIN = 'GET_PRODUCTOS_ADMIN'
export const GET_PRODUCTO_ADMIN = 'GET_PRODUCTO_ADMIN'
export const GET_PEDIDOS_ADMIN = 'GET_PEDIDOS_ADMIN'
export const GET_PEDIDO_ADMIN = 'GET_PEDIDO_ADMIN'

export const GET_METODOS_ENVIO = 'GET_METODOS_ENVIO'
export const GET_METODOS_ENVIO_ADMIN = "GET_METODOS_ENVIO_ADMIN";
export const GET_METODO_ADMIN = "GET_METODO_ADMIN"
export const ENVIA_METODO = "ENVIA_METODO"

export const UPDATE_PRECIO = 'UPDATE_PRECIO'

export const GUARDA_CUSTOM = 'GUARDA_CUSTOM'

export const TRAE_CIUDADES = 'TRAE_CIUDADES'
export const TRAE_PROVINCIAS = 'TRAE_PROVINCIAS'

const url_get_productos = 'http://sd-978075-h00005.ferozo.net:5792/api/prods/productos'
const url_get_producto = 'http://sd-978075-h00005.ferozo.net:5792/api/prods/producto'
const url_get_rubro = 'http://sd-978075-h00005.ferozo.net:5792/api/prods/productos'
const url_get_flias = 'http://sd-978075-h00005.ferozo.net:5792/api/prods/familias'
const url_menu = 'http://sd-978075-h00005.ferozo.net:5792/api/prods/menu'
const url_contacto = 'http://sd-978075-h00005.ferozo.net:5792/api/contacto'


export const eliminaDelCarro = (id)=>{
	return {
		type: ELIMINA_PROD_CARRO,
		id
	};
};

export const getProvincias = async () =>{
	try {
		const requestProvincias = await axios.get("https://apis.datos.gob.ar/georef/api/provincias");
		return {
			type: TRAE_PROVINCIAS,
			provincias: requestProvincias
		};
	} catch (err) {
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
}

export const getCiudades = async (provincia) => {
	try {
		const requestCiudades = await axios.get("https://apis.datos.gob.ar/georef/api/localidades?formato=json&provincia=" + provincia + "&max=5000");
		return {
			type: TRAE_CIUDADES,
			ciudades: requestCiudades
		};
	} catch (err) {
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
}

export const updateUser = async (u,data) =>{
	try {
		const enviaPerfil = await usuarioRef
			.doc(u)
			.update(data);
		return { 
			type: SEND_USER, 
			perfil: data 
		};
	} catch (err) {
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
}

export const guardaPago = async (data) => {
	try{
		const enviaPago = await pedidosRef.doc(data.external_reference).update({pago:data})
		return {
			type: GUARDA_PAGO
		}
	}catch(err){
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
}

export const enviaPedido = async (uid,destino,carro) => {
	try{
		const enviaPedido = await pedidosRef.add(destino)
		const id_pedido = enviaPedido.id.toString()
		var request
		//,i,arr,id_pedido

		//carro.map( async (prod) => {
		carro.forEach(async (prod) => {
			try{
				var producto=prod
				producto.id_pedido=id_pedido
				producto.uid=uid
				producto.stat=0
				var prodAdd = await pedidosContRef.add(producto)
			}catch(e){
				console.log(e)
			}
		})
		
		if (destino.contacto.condicion=="CONSUMIDORFINAL"){
			var pedidoData={
				destino,
				id_pedido,
				carro
			}
			//console.log(pedidoData)
			request = await axios.post('https://us-central1-veltonaccesos-113f7.cloudfunctions.net/prefPago',  pedidoData)
		}else{
			request=1
		}

		return {
			type: SEND_PEDIDO,
			payload:request,
			id: id_pedido
		}

	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
}

export const guardaCustom = (id_prod, customObjs) => {
	return {
		type: GUARDA_CUSTOM,
		id_prod,
		customObjs
	}
}

export const ponesacaProducto = (item, cantidad) => {
	return {
		type: ADDEL_PRODUCTO,
		item,
		cantidad
	}
}

export const agregaCarro = (precio) => {
	console.log("AGREGA")
	return {
		type: ADD_CART,
		precio
	}
}

export const sacaProducto = (pos) => {
	return {
		type: SACA_PRODUCTO,
		pos
	}
}

export const limpiaCarro = () => {
	return {
		type: LIMPIA_CARRO
	}
}

export const enviaContacto = async (data) => {
	data.t="VAcc8102"
	var request = await axios.post('https://us-central1-veltonaccesos-113f7.cloudfunctions.net/enviaContacto', data)
	return {
		type: ENVIA_CONTACTO,
  		payload:request.data
	}
}

export const getMenu = async () => {
  	try{
		const categorias = await categoriasRef.orderBy("rubro.orden").orderBy("orden").where("estado",'==',1).get()
		return {
			type: GET_MENU,
			categorias,
			meta:"1"
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
}

export const cambiaGal = (galeria) => {
	return {
		type: CAMBIA_GAL,
  		galeria
	}
}

export const cierraMenu = () => {
	console.log("CIERRA MENU")
	return {
		type: CIERRA_MENU
	}
}

export const getMetodosEnvio = async () => {
	const metodos = await enviometodosRef.orderBy("nombre", "desc").where("estado", '==', 1).get()
	return {
		type: GET_METODOS_ENVIO,
		metodos
	}
}

export const getMetodosAdmin = async () => {
	const metodos = await enviometodosRef.orderBy("nombre", "desc").get()
	return {
		type: GET_METODOS_ENVIO_ADMIN,
		metodos
	}
}

export const getMetodoAdmin = (id_metodo) => {
	return { type: GET_METODO_ADMIN, id_metodo };
}

export const enviaMetodo = async (metodo) => {
	try {
		if(metodo.hasOwnProperty("id")){
			console.log("ACTUALIZA")
			/*
			*/
			const metodoUp = await enviometodosRef
			.doc(metodo.id)
			.update({
				nombre: metodo.nombre,
				desc: metodo.desc,
				costo: metodo.costo,
				estado: metodo.estado
			});
			return {
				type: ENVIA_METODO,
				metodo,
				act: "up"
			}
		}else{
			/*
			*/
			console.log("AGREGA");
			const metodoAdd = await enviometodosRef.add(metodo);
			metodo.id=metodoAdd
			return {
				type: ENVIA_METODO,
				metodo,
				act:"add"
			}
		}
	} catch (error) {
		return { type: SEND_USER_MSJ, msj: error.message, tipo: 3 };
	}
}

export const getPedidos = async (uid) => {
	const pedidos = await pedidosRef.orderBy("fechaunix","desc").where("usuario.uid",'==',uid).get()
	return {
		type: GET_PEDIDOS,
  		pedidos
	}
}

export const getPedido = async (id_pedido) => {
	const pedidoCont = await pedidosContRef.where("id_pedido",'==',id_pedido).get()
	return {
		type: GET_PEDIDO,
		  pedidoCont,
			id_pedido
	}
}

export const getProductos = async (categoria) => {
	//console.log(categoria)
	var cat = categoria
	if (parseInt(categoria)!=NaN){
		cat = parseInt(cat)
	}
	const productos = await productosRef.orderBy("orden").orderBy("nombre").where("categoria.id",'==',cat).where("estado",'==',1).get()
	//console.log(productos)
	return {
		type: GET_PRODUCTOS,
  		productos
	}
}

export const getProducto = async (producto) => {
  	//const request = axios.get(url_get_producto+"/"+producto)
  	//console.log(url_get_producto+"/"+producto)
	const opciones = await productosRef.doc(producto).collection("opciones").orderBy("opcion.orden").orderBy("orden").where("estado",'==',1).get()
	const precios = await productosRef.doc(producto).collection("precios").orderBy("cantidad").get()
	return {
		type: GET_PRODUCTO,
  		opciones,
  		precios,
  		meta:producto
	}
}

export const buscaProducto = async (producto) => {
	const prod = await productosRef.doc(producto).get()
	return {
		type: TRAE_PRODUCTO,
  		prod
	}
}

export const traeProducto = async (id_prod) => {
	const producto = await productosRef.doc(id_prod).get();
	const opciones = await productosRef.doc(id_prod).collection("opciones").orderBy("opcion.orden").orderBy("orden").where("estado", '==', 1).get()
	const precios = await productosRef.doc(id_prod).collection("precios").orderBy("cantidad").get()
	return {
		type: TRAE_PRODUCTO_NEW,
		opciones,
		precios,
		producto
	}
}
/*
export const getFamilias = () => {
  	const request = axios.get(url_get_flias)
	return {
		type: GET_FLIAS,
  		payload:request
	}
}
export const getRubro = (rubro) => {
	const request = axios.get(url_get_rubro+rubro)
	return {
		type: GET_RUBRO,
		payload:request
	}
}
*/


export const getPedidosAdmin = async (pag) => {
	try{
		const pedidos = await pedidosRef.orderBy("fechaunix","desc").get()
		return {
			type: GET_PEDIDOS_ADMIN,
	  		pedidos
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
}

export const getPedidoAdmin = async (id_pedido) => {
	try{
		const pedidoCont = await pedidosContRef.where("id_pedido",'==',id_pedido).get()
		return {
			type: GET_PEDIDO_ADMIN,
	  		pedidoCont,
	  		id_pedido
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
}


export const getProductosAdmin = async (categoria) => {
	try{
		const productos = await productosRef.orderBy("rubro.id").orderBy("categoria.id").orderBy("orden").orderBy("nombre").get()
		return {
			type: GET_PRODUCTOS_ADMIN,
	  		productos
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
}

export const getProductoAdmin = async (producto) => {
  	try{
		const opciones = await productosRef.doc(producto).collection("opciones").orderBy("opcion.orden").orderBy("orden").get()
		const precios = await productosRef.doc(producto).collection("precios").orderBy("cantidad").get()
		return {
			type: GET_PRODUCTO_ADMIN,
	  		opciones,
	  		precios,
	  		meta:producto
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
}


// => dispatch
export const signIn =  async  (data) => {
	const perfil = { nombre: data.nombre, apellido: data.apellido, correo: data.user }
	try{
		const userS = await authRef.createUserWithEmailAndPassword(data.user, data.pass)
		const perfilS = await usuarioRef.doc(userS.user.uid).set(perfil)
		const profileS = await userS.user.updateProfile({ displayName: data.apellido+" "+data.nombre})
		return {
			type: REGISTRA_USER,
			user: userS.user,
			perfil:perfil
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
};

//=> dispatch
export const logIn = async (user, pass)  => {
	
	try{
		const userM = await authRef.signInWithEmailAndPassword(user, pass)
		const perfilM = await usuarioRef.doc(userM.user.uid).get()
		const idTokenResultLog = await authRef.currentUser.getIdTokenResult(true)
		
		var tipo="u"
		if(idTokenResultLog.claims.hasOwnProperty("isGod") && idTokenResultLog.claims.isGod){
			tipo="g"
		}else if(idTokenResultLog.claims.hasOwnProperty("isAdmin") && idTokenResultLog.claims.isAdmin){
			tipo="a"
		}else if(idTokenResultLog.claims.hasOwnProperty("isSlave") && idTokenResultLog.claims.isSlave){
			tipo="s"
		}

		return {
			type: LOG_USER,
			user: userM.user,
			perfil: perfilM.data(),
			tipo:tipo
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
};

export const resetPass = async (user)  => {
	
	try{
		const userReset = await authRef.sendPasswordResetEmail(user)
		return {
			type: RESET_PASS,
			msj: "SE LE ENVIO UN MAIL A SU CASILLA DE CORREO PARA GENERAR UNA NUEVA CONTRASEÑA",
			tipo: 1
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err.message,
			tipo: 3
		}
	}
};

export const guardaDireccion =  async  (uid,data) => {
	//console.log(uid)
	//console.log(data)
	try{
		const perfilM = await usuarioRef.doc(uid).collection("direcciones").add(data)
		return {
			type: ADD_DIRECCION,
			resp: 1,
		}
	}catch(err){
		return {
			type: SEND_USER_MSJ,
			resp: 0,
			msj: err.message,
			tipo: 3
		}
	}
}

export const guardaPedido =  async  (data) => {
	const cabecera = { 
		uid:data.uid,
		monto: data.monto, 
		id_direccion: data.id_direccion
	}

	try{
		const pedidoCabecera = await pedidosRef.add(cabecera)
		var batch = dbFirestore.batch();
		var cabeceraRef = pedidosRef.doc(pedidoCabecera).collection("detalle")
		data.detalle.map((item)=>{
			batch.add(cabeceraRef, item)
		})
		const pedidoDetalle  = await batch.commit()
		return {
			type: ADD_PEDIDO,
			resp: 1,
			msj: "Se agrego el pedido",
			tipo:1
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			resp: 0,
			msj: err,
			tipo: 3
		}
	}
};

export const guardaPrecio =  async  (id_prod,id_precio,precio) => {

	try{
		var precioNew=parseFloat(precio)
		const precioUp = await productosRef.doc(id_prod).collection("precios").doc(id_precio).update({precio:precioNew})
		return {
			type: UPDATE_PRECIO,
			id: id_precio,
			precio:parseFloat(precio)
		}
	}catch(err){
		return {
			type: SEND_USER_MSJ,
			resp: 0,
			msj: err,
			tipo: 3
		}
	}
}


//=> dispatch
export const signOut = async ()  => {
	try{
  		const signOutData = await authRef.signOut()
  		return {
			type: LOGOUT_USER
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			resp: 0,
			msj: err,
			tipo: 3
		}
	}
};

//=> dispatch
/*export const fetchUser = async ()  => {
	try{
  		const userData = await authRef.onAuthStateChanged()
    	if (userData) {
      		return {
				type: UPDATE_STAT,
				user:userData
			}
		}else{
			return {
				type: UPDATE_STAT,
				user:null
			}
		}
	}catch(err){
		console.log(err)
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
};
*/
export const estabaLogueado = async (user)  => {
	try{
		var tipo="u"
		const idTokenResult = await authRef.currentUser.getIdTokenResult(true)
		if(idTokenResult.claims.hasOwnProperty("isGod") && idTokenResult.claims.isGod){
			tipo="g"
		}else if(idTokenResult.claims.hasOwnProperty("isAdmin") && idTokenResult.claims.isAdmin){
			tipo="a"
		}else if(idTokenResult.claims.hasOwnProperty("isSlave") && idTokenResult.claims.isSlave){
			tipo="s"
		}
		const perfilLogueado = await usuarioRef.doc(user.uid).get()
		return {
			type: UPDATE_STAT,
			user: user,
			perfil: perfilLogueado.data(),
			tipo:tipo
		}
	}catch(err){
		return {
			type: SEND_USER_MSJ,
			msj: err,
			tipo: 3
		}
	}
};





// WEBPACK FOOTER //
// ./src/actions/index.js